import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FaWhatsapp } from "react-icons/fa";
import { ShieldCheck, Zap } from "lucide-react";
import { waLink, formatPrice } from "@/lib/constants";

export default function ProductCard({ product, index = 0 }) {
  const price = formatPrice(product.price);
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, delay: Math.min(index * 0.04, 0.3) }}
      data-testid="product-card"
      className="group flex flex-col overflow-hidden rounded-2xl border border-white/5 bg-[#12141C] transition-all duration-300 hover:-translate-y-1 hover:border-white/20"
    >
      <Link to={`/produk/${product.slug}`} className="relative block bg-[#0B0C10] p-4">
        <img
          src={product.image || "/assets/logo.png"}
          alt={`${product.name} ${product.variant || ""} - BigBerry Store`}
          loading="lazy"
          className="mx-auto h-44 w-full object-contain transition-transform duration-500 group-hover:scale-105"
        />
        {product.bestseller && (
          <span className="absolute left-3 top-3 rounded-full bg-berry px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-white">
            Best Seller
          </span>
        )}
        {!product.in_stock && (
          <span className="absolute right-3 top-3 rounded-full bg-black/70 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-gray-300">
            Habis
          </span>
        )}
      </Link>

      <div className="flex flex-1 flex-col p-4">
        <span className="mb-1 text-[11px] font-medium uppercase tracking-wider text-gray-500">
          {product.brand}
        </span>
        <Link to={`/produk/${product.slug}`}>
          <h3 className="font-heading text-base font-600 leading-tight text-white transition-colors group-hover:text-berry">
            {product.name}
          </h3>
        </Link>
        {product.variant && (
          <p className="mt-1 line-clamp-1 text-xs text-gray-400">{product.variant}</p>
        )}

        <div className="mt-3 flex flex-wrap gap-1.5">
          <span className="inline-flex items-center gap-1 rounded-full bg-white/10 px-2 py-0.5 text-[10px] font-medium uppercase tracking-wider text-white">
            <Zap className="h-3 w-3" /> Brand New
          </span>
          <span className="inline-flex items-center gap-1 rounded-full bg-electric/20 px-2 py-0.5 text-[10px] font-medium uppercase tracking-wider text-blue-400">
            <ShieldCheck className="h-3 w-3" /> Garansi Resmi
          </span>
        </div>

        <div className="mt-4 flex flex-1 flex-col justify-end">
          {price ? (
            <p data-testid="product-price" className="font-heading text-lg font-700 text-white">{price}</p>
          ) : (
            <p data-testid="product-price" className="text-sm font-medium text-gray-400">Hubungi via WhatsApp</p>
          )}
          <a
            href={waLink(`${product.name}${product.variant ? " " + product.variant : ""}`)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="product-card-whatsapp"
            className="mt-3 inline-flex items-center justify-center gap-2 rounded-full bg-whatsapp px-4 py-2 text-sm font-semibold text-white transition-all duration-300 hover:scale-[1.03] hover:bg-whatsapp-dark"
          >
            <FaWhatsapp className="h-4 w-4" /> Beli via WhatsApp
          </a>
        </div>
      </div>
    </motion.div>
  );
}
